<template>
  <empty-box class="my-list-item">
    <div class="btn-container">
      <template v-if="btnConfig.includes('查看证书')">
        <a-button type="link" @click="lookCertificate">查看证书</a-button>
        <a-modal
          wrapClassName="certificate-modal"
          title="证书"
          :visible="visible_certificate"
          width="948px"
          centered
          :footer="null"
          @cancel="visible_certificate = false"
        >
          <device-certificate ref="device-certificate" :data="data"></device-certificate>
          <div v-if="!$route.name.includes('anonymity-query-mobile')" class="download-btn-container">
            <a-button type="link" icon="download" @click="downloadImg('device-certificate')">下载为图片</a-button>
            <a-button type="link" icon="download" @click="downloadPDF">下载为pdf</a-button>
          </div>
        </a-modal>
      </template>

      <template v-if="btnConfig && btnConfig.includes('查看二维码')">
        <a-divider v-if="btnConfig && btnConfig.length > 1" type="vertical"></a-divider>
        <a-button type="link" @click="visible_qrcode = true">查看二维码</a-button>
        <a-modal
          title="二维码"
          :visible="visible_qrcode"
          width="248px"
          centered
          :footer="null"
          @cancel="visible_qrcode = false"
        >
          <device-qrcode ref="device-qrcode" :serialNumber="data.serialNumber"></device-qrcode>
          <div class="download-btn-container">
            <a-button type="link" icon="download" @click="downloadImg('device-qrcode')">下载为图片</a-button>
          </div>
        </a-modal>
      </template>

      <template v-if="btnConfig && btnConfig.includes('查看文件')">
        <a-divider v-if="btnConfig && btnConfig.length > 1" type="vertical"></a-divider>
        <a-button type="link" @click="clickLookFile(data.id)">查看文件</a-button>
      </template>

      <template v-if="$store.state.role === 'admin' && btnConfig && btnConfig.includes('修改配置')">
        <a-divider v-if="btnConfig.length > 1" type="vertical"></a-divider>
        <a-button type="link" @click="toDeviceFModify(data.id,data.productID,data.serialNumber)">修改配置</a-button>
      </template>

      <template v-if="$store.state.role === 'admin' && btnConfig.includes('删除')">
        <a-divider v-if="btnConfig && btnConfig.length > 1" type="vertical"></a-divider>
        <a-button type="link" @click="clickDelete(data.id)">删除设备</a-button>
      </template>

      <template v-if="btnConfig && btnConfig.includes('修改密码')">
        <a-divider v-if="btnConfig && btnConfig.length > 1" type="vertical"></a-divider>
        <a-button type="link">修改密码</a-button>
      </template>
    </div>

    <a-descriptions class="my-descriptions" :title="data.productName">
      <template v-if="data.source == 2">
        <a-descriptions-item label="串号">{{data.serialNumber}}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{data.createTime | timeFormat}}</a-descriptions-item>
      </template>
      <template v-else>
        <a-descriptions-item label="生产者账号">{{data.producerUsername}}</a-descriptions-item>
        <a-descriptions-item label="生产者姓名">{{data.producerName}}</a-descriptions-item>
        <!-- <a-descriptions-item label="产品ID">{{data.productID}}</a-descriptions-item> -->
        <a-descriptions-item label="串号">{{data.serialNumber}}</a-descriptions-item>
        <a-descriptions-item label="通信编号">{{data.communicationSerialNo}}</a-descriptions-item>
        <a-descriptions-item label="激活时间">{{data.activeTime | timeFormat}}</a-descriptions-item>
        <a-descriptions-item label="剩余可激活次数">{{data.activableNumber}}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{data.createTime | timeFormat}}</a-descriptions-item>

        <a-descriptions-item label="用户单位">{{data.userCompany}}</a-descriptions-item>
        <a-descriptions-item label="用户手机号">{{data.userPhone}}</a-descriptions-item>
        <a-descriptions-item label="备案时间">{{data.recordTime | timeFormat}}</a-descriptions-item>
        <a-descriptions-item label="保修到期时间">{{data.warrantyDate | timeFormat}}</a-descriptions-item>

        <!-- <a-descriptions-item v-if="$route.name==='query-auth-history'" label="设备ID">{{data.deviceID}}</a-descriptions-item> -->
        <a-descriptions-item v-if="$route.name==='query-auth-history'" label="操作类型">{{data.recordType}}</a-descriptions-item>
        <a-descriptions-item
          v-if="$route.name==='query-auth-pre' || $route.name==='device-query'"
          label="串号密钥"
        >{{data.serialCipher}}</a-descriptions-item>
        <a-descriptions-item
          v-if="$route.name==='device-query' || $route.name.includes('anonymity-query')"
          label="授权码"
        >{{data.authorizationCode}}</a-descriptions-item>
        <!-- <a-descriptions-item
          v-if="$route.name==='device-query' || $route.name.includes('anonymity-query')"
          label="授权算法类型"
        >{{data.algorithmType}}</a-descriptions-item>-->
        <a-descriptions-item
          v-if="$route.name==='device-query' || $route.name.includes('anonymity-query')"
          label="修改时间"
        >{{data.modifyTime | timeFormat}}</a-descriptions-item>
        <a-descriptions-item label="配置码">{{data.config}}</a-descriptions-item>
      </template>
      
    </a-descriptions>


    <div class="more-container" ref="more-container">
      <div class="more-container-content" ref="more-container-content">
        <template v-if="data.source!=2">
          <span class="table-name">功能授权</span>
          <a-table
            class="my-table"
            :columns="columns_func"
            :dataSource="functions"
            :pagination="false"
            :rowKey="record => record.functionId"
          >
            <template #startTime="text">
              <span>{{text?moment(text).format('YYYY-MM-DD'):'1970-01-01'}}</span>
            </template>

            <template #endTime="text">
              <span>{{text?moment(text).format('YYYY-MM-DD'):'永久'}}</span>
            </template>

            <template #enabled="text">
              <a-badge :status="text ?'success' : 'error'" :text="text?'已授权':'未授权'" />
            </template>
          </a-table>
        </template>
        <span class="table-name" v-if="data.source!=2">扩展属性</span>
        <a-table
          class="my-table"
          :columns="data.source!=2 ? columns_attr : columns_attr.filter(column => column.dataIndex !== 'keyEn')"
          :dataSource="extendedAttributes"
          :pagination="false"
          :rowKey="record => record.key"
        />
        <div class="list-wrap" v-if="frequencyList && frequencyList.length">
          <div class="list" v-for="(item, index) in frequencyList" :key="index">
            <div class="list-item" v-for="(vitem, vindex) in item" :key="vindex">{{ vitem }}</div>
          </div>
        </div>
        <div class="img-wrap" v-if="picList && picList.length">
          <div class="img-box" v-for="(item, index) in picList" :key="item.fileUrl">
            <!-- 图片类：显示缩略图 -->
            <img v-if="isImageFile(item)" class="img" :src="item.fileUrl" alt="">
            <!-- 文档类：显示文件图标占位 -->
            <div v-else class="doc-placeholder">
              <a-icon type="file" style="font-size: 32px; color: rgba(0,0,0,0.25)" />
              <span class="doc-name">{{ getFileName(item) }}</span>
            </div>
            <div class="cover flex-center">
              <a-icon
                v-if="isImageFile(item)"
                type="eye"
                class="preview pointer"
                @click="handlePreview(item)"
              />
              <a-icon
                v-else
                type="download"
                class="preview pointer"
                @click="handleDownload(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-button v-if="$route.name !== 'anonymity-query-mobile'" class="spread-btn" type="link" @click="clickSpread">
      <span>{{spread ? '收起' : '展开'}}</span>
      <a-icon :type="spread ? 'up' : 'down'" />
    </a-button>

    <LookFileModal :visible.sync="visible_file" :deviceId="deviceId" />

    <preview-img-modal :visible.sync="previewImgVisible" :imgList="imgList" :img-index="imgIndex" />
  </empty-box>
</template>

<script>
import moment from 'moment'
import jsPDF from 'jspdf'
import domtoimage from 'dom-to-image'
import { deleteDevice } from '../api/api'
import LookFileModal from './LookFileModal'
import PreviewImgModal from './PreviewImgModal'

const columns_func = [
  {
    title: '授权功能名称',
    dataIndex: 'name',
    width: '25%'
  },
  {
    title: '授权开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' },
    width: '25%'
  },
  {
    title: '授权结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' },
    width: '25%'
  },
  {
    title: '授权状态',
    dataIndex: 'enabled',
    scopedSlots: { customRender: 'enabled' },
    width: '25%'
  }
]

const columns_attr = [
  {
    title: '属性名',
    dataIndex: 'key',
    width: '33%'
  },
  {
    title: '属性英文名',
    dataIndex: 'keyEn',
    width: '33%'
  },
  {
    title: '属性值',
    dataIndex: 'value',
    width: '33%'
  }
]


export default {
  name: 'my-list-item',

  components: {
    LookFileModal,
    PreviewImgModal
  },

  props: {
    data: Object,
    btnConfig: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  data() {
    return {
      spread: false, //是否展开
      columns_func,
      columns_attr,
      visible_qrcode: false,
      visible_certificate: false,
      visible_file: false,

      deviceId: '',
      currentColums: [],
      frequencyList: [],
      previewImgVisible: false,
      imgList: [],
      imgIndex: 0
    }
  },

  computed: {
    functions() {
      let arr = this.data.functions
      if (this.$route.name.includes('mobile')) {
        arr = arr.filter(item => item.enabled)
      }
      return arr
    },

    extendedAttributes() {
      let arr = this.data.extendedAttributes.filter(
        item => item.key && !['certificate', '频响修正值', '频响修正频率', '频响修正名称'].includes(item.key)
      )

      const frequencyData = this.data.extendedAttributes.filter(item => item.key && ['频响修正值', '频响修正频率'].includes(item.key))
      if (frequencyData.length) {
        const frequency = frequencyData.find(item => item.keyEn == 'Frequency')
        const values = frequencyData.find(item => item.keyEn == 'Values')
        const frequencyDataList = frequency ? JSON.parse(frequency.value) : []
        const valuesDataList = values ? JSON.parse(values.value) : []

        frequencyDataList.unshift('频率(Hz)')
        valuesDataList.unshift('静电激励响应到自由场频率响应修正(dB)')

        this.frequencyList = [frequencyDataList, valuesDataList]
      }
      if (this.$route.name.includes('mobile')) {
        arr.forEach(
          item => (item.key = item.key.substring(item.key.indexOf(']') + 1))
        )
      }
      return arr
    },

    host() {
        return window.location.origin
    },
    picList() {
      const { deviceFiles } = this.data
      const picData = deviceFiles && deviceFiles.filter(item => item.fileType == 3)
      return picData || []
    }
  },

  mounted() {
    this.spread = this.$route.name.includes('anonymity-query') ? true : false
  },

  updated() {
    if (this.spread) {
      this.$refs['more-container'].style.height =
      this.$refs['more-container-content'].clientHeight + 'px'
    } else {
      this.$refs['more-container'].style.height = '0px'
    }
  },

  methods: {
    moment,

    clickSpread() {
      this.spread = !this.spread
    },

    downloadImg(el) {
      let dom = this.$refs[el].$el
      domtoimage
        .toJpeg(dom, {
          bgcolor: 'white'
        })
        .then(function(dataUrl) {
          var link = document.createElement('a')
          link.download = el === 'device-qrcode' ? '二维码' : '证书'
          link.href = dataUrl
          link.click()
        })
    },

    downloadPDF() {
      let dom = this.$refs['device-certificate'].$el
      domtoimage
        .toJpeg(dom, {
          bgcolor: 'white'
        })
        .then(function(dataUrl) {
          var doc = new jsPDF({
            orientation: 'p', //竖着
            unit: 'pt', //单位
            format: 'a4'
          })
          doc.addImage(dataUrl, 'JPEG', 40, 40, 515, 324)
          doc.save('证书.pdf')
        })
    },

    toDeviceFModify(deviceID, productID, serialNumber) {
      this.$router.push({
        name: 'device-modify',
        query: {
          deviceID,
          productID,
          serialNumber
        }
      })
    },

    clickDelete(id) {
      this.$confirm({
        title: '确定删除吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          deleteDevice(id).then(res => {
            if (res.error.code === 0) {
              this.$message.success('删除成功')
              this.$parent.fetchData()
            }
          })
        }
      })
    },

    lookCertificate() {
      let keys = this.data.extendedAttributes.map(item => item.key)
      if (
        keys.includes('certificate-productDescription') &&
        keys.includes('certificate-licenceDescription') &&
        keys.includes('certificate-companyDescription') &&
        this.data.authorizationCode
      ) {
        this.visible_certificate = true
      } else {
        this.$message.error('缺少信息')
      }
    },

    clickLookFile(deviceId) {
      this.visible_file = true
      this.deviceId = deviceId
    },

    // 判断是否为图片类型（按扩展名）
    isImageFile(item) {
      const url = (item.fileUrl || item.fileName || '').toLowerCase()
      const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg']
      return imageExts.some(ext => url.includes(ext))
    },

    // 获取文件名用于展示
    getFileName(item) {
      const name = item.fileName || item.fileUrl || ''
      const parts = name.split(/[/\\]/)
      const full = parts[parts.length - 1] || '文档'
      return full.length > 12 ? full.slice(0, 10) + '…' : full
    },

    // 预览图片（仅图片类）
    handlePreview(item) {
      const imageList = this.picList.filter(i => this.isImageFile(i))
      const idx = imageList.findIndex(i => i.fileUrl === item.fileUrl)
      if (idx === -1) return
      this.imgList = imageList
      this.imgIndex = idx
      this.previewImgVisible = true
    },

    // 下载文档（文档类直接下载）
    handleDownload(item) {
      const url = item.fileUrl
      if (!url) {
        this.$message.warning('文件地址无效')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      link.download = item.fileName || url.split(/[/\\]/).pop() || '下载文件'
      link.click()
    },
  }
}
</script>

<style scoped lang="less">
.download-btn-container {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-list-item {
  position: relative;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
}

.btn-container {
  position: absolute;
  right: 9px;
  top: 18px;
  .ant-divider-vertical {
    margin: 0;
  }
}

.spread-btn {
  display: block;
  margin: 0 auto;
}

.more-container {
  height: 0px;
  overflow: hidden;
  transition: all 0.6s;
  box-sizing: border-box;
  .more-container-content {
    padding-bottom: 24px;
    box-sizing: border-box;
  }
}

.table-name {
  display: block;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  font-size: 15px;
  padding: 24px 0px;
}
.list-wrap {
  margin-top: 10px;
  border-top: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}
.list,
.img-wrap {
  display: flex;
  align-content: center;
}
.list-item {
  flex: 1;
  height: 48px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  &:first-child {
    min-width: 140px;
  }
}
.img-wrap {
  margin-top: 10px;
}
.img-box {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-left: 10px;
  &:first-child {
    margin-left: 0;
  }
  .img {
    max-width: 100%;
    max-height: 100%;
  }
  .doc-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 8px;
    .doc-name {
      margin-top: 8px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      text-align: center;
      word-break: break-all;
      max-width: 100%;
    }
  }
}

.cover {
  position: absolute;
  top: 4px;
  left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.5s;
  opacity: 0;
  .preview,
  .del {
    cursor: pointer;
  }
  .preview {
    color: rgba(255, 255, 255, 0.8);
    font-size: 42px;
  }
  .del {
    position: absolute;
    top: 4px;
    right: 4px;
  }
}

.img-box {
  &:hover {
    .cover {
      opacity: 1;
    }
  }
}
</style>
